export const getLiveEdgeInSeconds = state => state.player.liveEdgeInSeconds;

export const isOnLive = state => state.player.isOnLive || false;
